import { currentRefinements } from 'instantsearch.js/es/widgets'

const widget = document.querySelector('[data-widget="refinements"]')
export const refinements = widget == null ? false : currentRefinements({
  container: widget,
  // Optional parameters
  // includedAttributes: string[],
  // excludedAttributes: string[],
  // cssClasses: object,
  // transformItems: function,
})
